import { render, staticRenderFns } from "./credit-batch-application.vue?vue&type=template&id=2c1915d8&scoped=true"
import script from "./credit-batch-application.vue?vue&type=script&lang=js"
export * from "./credit-batch-application.vue?vue&type=script&lang=js"
import style0 from "./credit-batch-application.vue?vue&type=style&index=0&id=2c1915d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1915d8",
  null
  
)

export default component.exports